import { render } from "./DeleteClientModal.vue?vue&type=template&id=0eec0ec4&scoped=true&ts=true"
import script from "./DeleteClientModal.vue?vue&type=script&lang=ts"
export * from "./DeleteClientModal.vue?vue&type=script&lang=ts"

import "./DeleteClientModal.vue?vue&type=style&index=0&id=0eec0ec4&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0eec0ec4"]])

export default __exports__